import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="text-6xl font-bold text-distrito-700">404</div>
      <h1 className="mt-4 text-2xl font-semibold text-gray-900">Página no encontrada</h1>
      <p className="mt-2 text-gray-600 max-w-md">
        La ruta solicitada no existe o fue movida. Regresa al inicio o usa el menú superior.
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex items-center px-4 py-2 bg-distrito-600 text-white rounded-md hover:bg-distrito-700 transition"
      >
        Volver al inicio
      </Link>
    </div>
  );
}
